import './index.scss';

import 'utils/floating_labels';
import FormSubmitToggle from 'utils/form_submit_toggle';
new FormSubmitToggle('#registration_form', true);
